module.exports = __webpack_public_path__ + "img/fiji.ab5dca4a.png";